export default __webpack_public_path__ + "static/media/43.eb94161f.svg";